__webpack_require__.p = "/dashboard/www/earnapp_cp/pub/packs/";